module.exports = __webpack_public_path__ + "277af7870e80bb1354ee938c44a8dd2d.pdf";